module.exports = __webpack_public_path__ + "static/media/_lkSqQXX-5I.8d4b60b8.jpg";